export const isNotNullOrUndefined = <T extends unknown>(
  itm: T | null | undefined,
): itm is T => itm !== null && itm !== undefined;
